const cAndIdBlock = 'map-shops';

function loadScript() {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const scriptYandexMapUrl = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=36184aa5-8afc-454e-bdfb-df0a3a0d667d';

        if (document.getElementById(cAndIdBlock)) {
            resolve();
        }

        script.onload = () => {
            resolve();
        };

        script.onerror = () => {
            reject();
        };

        script.id = cAndIdBlock;
        document.head.insertBefore(script, document.head.firstChild);
        script.src = scriptYandexMapUrl;
    });
}

function init() {
    loadScript()
        .then(() => {
            function createMap() {
                const geolocation = window.ymaps.geolocation;
                const myMap = new window.ymaps.Map('map', {
                    center: [55, 34],
                    zoom: 10,
                }, {
                    searchControlProvider: 'yandex#search',
                });
                const objectManager = new window.ymaps.ObjectManager({
                    // Чтобы метки начали кластеризоваться, выставляем опцию.
                    clusterize: true,
                    // ObjectManager принимает те же опции, что и кластеризатор.
                    gridSize: 32,
                    clusterDisableClickZoom: true
                });

                geolocation.get({
                    provider: 'yandex',
                    mapStateAutoApply: true,
                })
                    .then((result) => {
                        // Выделение положения, вычисленного через ip
                        result.geoObjects.get(0).properties.set({
                            balloonContentBody: 'Ваш город',
                        });

                        myMap.geoObjects.add(result.geoObjects);
                        // Чтобы задать опции одиночным объектам и кластерам,
                        // обратимся к дочерним коллекциям ObjectManager.
                        objectManager.objects.options.set('preset', 'islands#orangeDotIcon');
                        objectManager.clusters.options.set('preset', 'islands#orangeClusterIcons');
                        myMap.geoObjects.add(objectManager);

                        // Получение меток
                        $.ajax({
                            url: $(`.${cAndIdBlock}`).attr('data-href'),
                        }).done((data) => {
                            const arrLabels = [];
                            const dataJson = JSON.parse(data);

                            dataJson.forEach((item, key) => {
                                arrLabels.push({
                                    'type': 'Feature',
                                    'id': key,
                                    'geometry': {
                                        'type': 'Point',
                                        'coordinates': [item.coords.latitude, item.coords.longitude],
                                    },
                                    'properties': {
                                        'balloonContentHeader': `<b>${item.name}</b>`,
                                        'balloonContentBody': `
                                            <p class="map-shops__map-address">${item.address}</p>
                                            ${item?.link?.name ? `<a href="${item.link.url}" class="map-shops__map-link" target="_blank">${item.link.name ? item.link.name : item.link.url}</a>` : ''}
                                        `,
                                        'hintContent': item.name,
                                    },
                                });
                            });

                            objectManager.add({
                                'type': 'FeatureCollection',
                                'features': arrLabels,
                            });
                        });
                    })
                    .catch(console.log);
            }

            window.ymaps.ready(createMap);
        })
        .catch(() => console.log('Api Яндекс карт не загрузилось!'));
}

init();